<template>
  <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <base-card
      :title="isEntryMode ? 'Add Customer Kpi' : 'Update Customer Kpi'"
      :v-card-text-class="'pa-4'"
    >
      <v-form @submit.prevent="submit" ref="InvCustomerKpiSetup">
        <v-row>
          <v-col cols="12">
            <v-text-field
              density="compact" 
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="name.value.value"
              :error-messages="name.errorMessage.value"
              clearable
            >
              <template #label>
                Name <span class="text-red-accent-4">*</span>
              </template>
            </v-text-field>

            <v-text-field
              density="compact" 
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="weight.value.value"
              :error-messages="weight.errorMessage.value"
              clearable
            >
              <template #label>
                Weight <span class="text-red-accent-4">*</span>
              </template>
            </v-text-field>

            <v-textarea
              label="Remarks (Optional)"
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="remarks.value.value"
              :error-messages="remarks.errorMessage.value"
              clearable
              auto-grow
              rows="2"
            ></v-textarea>
            <v-checkbox
              label="Active"
              v-model="status.value.value"
              :error-messages="status.errorMessage.value"
              density="compact"
              variant="outlined"
              hide-details
              single-line
              color="primary"
              value="1"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="justify-end">
            <v-btn
              class="bg-red"
              variant="flat"
              type="reset"
              @click="closeDialog"
              >Close</v-btn
            >
            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
              {{ isEntryMode ? "Save" : "Update" }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-form>
    </base-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";
import baseCard from "@/components/utils/baseCard.vue";

export default {
  name: "InvCustomerKpiSetup",
  components: {
    baseCard
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        type: "",
        name: "",
        weight: "",
        status: "1",
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: "",
      preview: "/src/assets/no_preview.jpeg",
      loading: false,
      isEntryMode: true,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.customer_kpi_id.setValue(newData.id || "", false);
        this.type.setValue(newData.type || null, false);
        this.name.setValue(newData.name || null, false);
        this.weight.setValue(newData.weight || null, false);
        this.remarks.setValue(newData.remarks || null, false);
        this.status.setValue(String(newData.status) || "1", false);
      },
    },
  },
  created() {},
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {

    const store = useStore();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        type: yup.string().required().trim().label("Type"),
        name: yup.string().min(5).max(250).required().trim().label("Name"),
        weight: yup.number().required().label("Weight"),
        remarks: yup.string().nullable().trim().label("Remarks"),
      }),
    });

    const customer_kpi_id = useField("customer_kpi_id");
    const type = useField("type");
    const name = useField("name");
    const weight = useField("weight");
    const status = useField("status");
    const remarks = useField("remarks");
    const errorMessages = ref("");
    const loading = ref("");

    const submit = handleSubmit((values) => {
      values.type = "customer"; 

      let storeAction = "saveInvCustomerKpi";
      if (values.customer_kpi_id) {
        storeAction = "updateInvCustomerKpi";
      }

      store
        .dispatch(storeAction, values)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          loading.value = true;
          store
            .dispatch("getInvCustomerKpisList", {type: "customer"})
            .then((data) => {
              loading.value = false;
            })
            .catch((error) => {
              loading.value = false;
              toast.error(error.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      customer_kpi_id,
      type,
      name,
      weight,
      remarks,
      status,
      errorMessages,
      loading,
      resetForm,
    };
  },
  mounted() {},
};
</script>
